/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { ROUTES } from '@kamernet/core/Routing/routes';
import { ListingsSearchCategory } from '@kamernet/core/Routing/routes/ListingsSearch';

import styles from './Content.module.css';

export const ContentCountryApartment = () => {
  const { locale } = useIntl();
  const searchCategories = [ListingsSearchCategory.Apartment];

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Apartments for rent in Netherlands
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Looking for the best apartment rental site in the Netherlands? Look no
        further! Kamernet is the premier platform for finding apartments for
        rent in Netherlands for short-term and long-term. Our platform
        meticulously curates listings from trusted landlords ensuring you find
        the perfect home without compromise.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Why Choose an Apartment in Netherlands?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Apartments in the Netherlands offer diverse living options suitable
            for various needs and preferences. From vibrant city centres to
            tranquil suburban neighbourhoods, there's an apartment to match
            every lifestyle. Whether you're a young professional, a couple, or a
            growing family, an apartment in the Netherlands offers a versatile
            and welcoming living environment.`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Renting an apartment in Netherlands is effortless with our extensive
        search features and detailed listings. Each property is meticulously
        vetted to provide accurate descriptions and quality images to empower
        you to make informed decisions from the comfort of your home. Benefit
        from our commitment to transparency and reliability as customer support
        is there to guide you and provide answers to all your questions.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Looking for affordable apartments in the Netherlands? Our platform
        offers affordable rental properties throughout the country, so you can
        find the perfect place to feel at home. With Kamernet, finding an
        apartment in the Netherlands has never been easier. Simply browse our
        listings, filter based on your desired criteria, create a search alert,
        receive real-time email notifications, and find the perfect rental with
        just a few clicks. So, what are you waiting for? Start your search today
        and rent an apartment in the Netherlands.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Useful Links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'almere', searchCategories },
          Locale.en,
        )}
      >
        Almere apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nijmegen', searchCategories },
          Locale.en,
        )}
      >
        Nijmegen apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hilversum', searchCategories },
          Locale.en,
        )}
      >
        Hilversum apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'eindhoven', searchCategories },
          Locale.en,
        )}
      >
        Eindhoven apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hoofddorp', searchCategories },
          Locale.en,
        )}
      >
        Hoofddorp apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zaandam', searchCategories },
          Locale.en,
        )}
      >
        Zaandam apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'arnhem', searchCategories },
          Locale.en,
        )}
      >
        Arnhem apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'tilburg', searchCategories },
          Locale.en,
        )}
      >
        Tilburg apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'enschede', searchCategories },
          Locale.en,
        )}
      >
        Enschede apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'amersfoort', searchCategories },
          Locale.en,
        )}
      >
        Amersfoort apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zeist', searchCategories },
          Locale.en,
        )}
      >
        Zeist apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'breda', searchCategories },
          Locale.en,
        )}
      >
        Breda apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'maastricht', searchCategories },
          Locale.en,
        )}
      >
        Maastricht apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nieuwegein', searchCategories },
          Locale.en,
        )}
      >
        Nieuwegein apartments
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'schiedam', searchCategories },
          Locale.en,
        )}
      >
        Schiedam apartments
      </NavLink.Anchor>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Appartementen te huur in Nederland
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Op zoek naar de beste site voor appartementenverhuur in Nederland? Zoek
        niet verder! Kamernet is het leidende platform voor het vinden van
        appartementen te huur in Nederland voor korte en lange termijn. Ons
        platform verzamelt zorgvuldig advertenties van betrouwbare verhuurders,
        zodat je zonder problemen de perfecte woning vindt.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Waarom kiezen voor een appartement in Nederland?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Appartementen in Nederland bieden diverse woonopties die geschikt zijn
        voor verschillende behoeften en voorkeuren. Van levendige stadscentra
        tot rustige buitenwijken, er is een appartement dat past bij elke
        levensstijl. Of je nu een jonge professional bent, een stel of een
        groeiend gezin, een appartement in Nederland biedt een veelzijdige en
        gastvrije leefomgeving.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Een appartement huren in Nederland is moeiteloos met onze
            uitgebreide zoekfuncties en gedetailleerde advertenties. Elke woning
            is zorgvuldig doorgelicht om nauwkeurige beschrijvingen en
            kwaliteitsfoto's te bieden, zodat je gemakkelijk vanuit je eigen
            huis goed overwogen beslissingen kunt nemen. Profiteer van onze
            inzet voor betrouwbaarheid en transparantie. Wees ervan verzekerd
            dat onze klantenservice klaar staat om je te begeleiden en al je
            vragen te beantwoorden.`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Op zoek naar betaalbare appartementen in Nederland? Ons platform biedt
        betaalbare huurwoningen door het hele land, zodat je de perfecte plek
        kunt vinden om je thuis te voelen. Met Kamernet is het vinden van een
        appartement in Nederland eenvoudiger dan ooit. Zoek eenvoudig in ons
        aanbod, filter op je gewenste criteria, creëer een zoekopdracht, ontvang
        real-time e-mailnotificaties en vind de perfecte huurwoning met slechts
        een paar klikken. Dus waar wacht je nog op? Begin vandaag nog je
        zoektocht en huur een appartement in Nederland.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Handige links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'almere', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Almere
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nijmegen', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Nijmegen
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hilversum', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Hilversum
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'eindhoven', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Eindhoven
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hoofddorp', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Hoofddorp
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zaandam', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Zaandam
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'arnhem', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Arnhem
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'tilburg', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Tilburg
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'enschede', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Enschede
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'amersfoort', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Amersfoort
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zeist', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Zeist
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'breda', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Breda
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'maastricht', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Maastricht
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nieuwegein', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Nieuwegein
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'schiedam', searchCategories },
          Locale.nl,
        )}
      >
        Appartement Schiedam
      </NavLink.Anchor>
    </React.Fragment>
  );
};
